import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const clearCart = unaryRpc({
  name: "clearCart" as const,
  input: z.void(),
  output: z.object({ success: z.boolean() }),
});
